export default __webpack_public_path__ + "static/media/ReleaseNotes_LoadRequest_Message.94bf5468.png";